import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class PlanService {

    static getPlan(item) {

        let api = `${API_BASE_URL}${API_PATHS.getPlan}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addPlan(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addPlan}`;
        return axiosInstance
            .post(api, data)

    }

    static assignPlan(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.assignPlan}`;
        return axiosInstance
            .post(api, data)

    }

    static editPlan(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editPlan}`;
        return axiosInstance
            .put(api, data)

    }

    static deletePlan(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletePlan}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default PlanService;
